/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull di_web'
 *
 * Required dependencies: amplitude-js@^8.21.0
 * Tracking Plan Version: 101
 * Build: 1.0.0
 * Runtime: browser:javascript-ampli
 *
 * [View Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/oi/Octopus%20Investments/implementation/di_web)
 */

import amplitude from 'amplitude-js';

/**
 * @typedef BaseEvent
 * @type {object}
 * @property {string} event_type
 * @property {Object.<string, *>} [event_properties]
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} [branch]
 * @property {string} [source]
 * @property {string} [version]
 * @property {string} [versionId]
 */

/**
 * Data to be processed by middleware
 * @typedef MiddlewarePayload
 * @type {object}
 * @property {BaseEvent} event
 * @property {MiddlewareExtra} [extra]
 */

/**
 * Function called at the end of each Middleware to run the next middleware in the chain
 * @typedef MiddlewareNext
 * @type {function}
 * @param {MiddlewarePayload} payload
 *
 * @return
 */

/**
 * A function to run on the Event stream (each logEvent call)
 * @typedef Middleware
 * @type {function}
 * @param {MiddlewarePayload} payload The event and extra data being sent
 * @param {MiddlewareNext} next Function to run the next middleware in the chain, not calling next will end the middleware chain
 * @return
 */

/**
 * @typedef LoadClientOptions
 * @type {object}
 * @property {string} [apiKey]
 * @property {Object} [options]
 * @property {AmplitudeClient} [instance]
 */

/**
 * @typedef LoadOptions
 * @type {object}
 * @property {'production'|'development'} [environment]
 * @property {boolean} [disabled]
 * @property {LoadClientOptions} [client]
 */

/**
 * @typedef {Object} EventOptions
 * @type {object}
 */

/**
 * @typedef {Object} IdentifyOptions
 * @type {object}
 */

/**
 * @typedef {Object} GroupOptions
 * @type {object}
 */

/**
 * @typedef {Object} MiddlewareExtra
 * @type {Object.<string, *>}
 */

/**
 * @typedef ApiKey
 * @type {object}
 * @property {string} production
 * @property {string} development
 */
export const ApiKey = {
  production: 'ff0df4022bd7df6de9c07cf7ac20b789',
  development: '0dbb192d76d32322d153510ee5143987'
};

/**
 * @typedef {Object} AllRequired
 * @param {*} [source_website] Property has no description in tracking plan.
 * @param {string} [user_id] the id of the user
 * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [user_type] Property has no description in tracking plan.
 * @param {boolean} [view_as] Has this event been triggered by someone 'Viewing As' the customer
 */

/**
 * @typedef {Object} BeaconArticle
 * @param {string} [article_id] The id of the knowledge base article clicked
 */

/**
 * @typedef {Object} ContentNavigation
 * @param {'Account information'|'Back to Clients'|'Back to Investments'|'Breadcrumb Client Name'|'Breadcrumb My Clients'|'Discover more'|'Future Gen back to Portfolio Stories'|'Portfolio Stories'|'FGVCT Product page'|'Close icon'|'New snippet'|'New tab'|'Back to my account'|'Try again'} [navigation_type] the method of navigation
 */

/**
 * @typedef {Object} DiCriteria
 * @param {boolean} [di_email_criteria_met] Incorrect OR correct
 * @param {boolean} [di_password_criteria_met] Property has no description in tracking plan.
 * @param {boolean} [di_passwords_match] True or False
 */

/**
 * @typedef {Object} DiDataEntered
 * @param {string} [di_con_entered] Property has no description in tracking plan.
 * @param {string} [di_email_entered] Property has no description in tracking plan.
 */

/**
 * @typedef {Object} DiStatus
 * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
 * @param {boolean} [is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
 * @param {boolean} [mfa_status] Has the customer got MFA enabled
 */

/**
 * @typedef {Object} Email
 * @param {string} [email] the email address of the user
 */

/**
 * @typedef {Object} Errors
 * @param {string} [error_code] A value we will sent, that means something   e.g. Page not found, document not found etc.
 * @param {string} [error_message] The description of the error - extra details
 * @param {string} [error_name] The "Redux store object name" that identifies the error in the codebase
 * @param {string} [error_referrer] The page the user was on when they encountered the error - e.g. https://portal.octopusinvestments.com/clients
 * @param {number} [error_status] e.g 500; 404 etc.
 */

/**
 * @typedef {Object} ExternalLink
 * @param {'beacon - no clients'|'mailto:support@octopusinvestments.com'|'fgvct_simon_rogerson'|'fgvct_octopus_giving'|'0800 316 2295'|'beacon - tab error'|'new_investor'|'change_details'|'missing_fields'|'new_adviser'|'continue_new_investor'|'continue_missing_fields'|'0800 316 2067'|'mfa_microsoft'|'mfa_google'|'beacon_mfa_contact'|'mfa_apple'|'ill_expired_login'|'beacon_get_in_touch'|'ill_expired_create'|'ill_expired_contact'} [external_link_clicked] The external link clicked - either from event external_link_clicked or external_app_clicked or embedded_beacon_clicked
 */

/**
 * @typedef {Object} Location
 * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
 */

/**
 * @typedef {Object} Search
 * @param {'scv'|'client_list'|'investment_details'|'illustration_investment_details'|'application_investment_details'} [destination] The page the user navigates to
 * @param {string} [search_content] what the user is searching for - the string of characters in the input value when dropdown is closed
 * @param {'clients'|'amount'|'advisers'} [search_type] What is the user searching for
 * @param {boolean} [successful] Has the customer successfully selected an item from the dropdown
 */

/**
 * @typedef {Object} Tooltips
 * @param {'accrued_fees'|'adviser_charges'|'amc'|'cash_statement'|'con'|'current_value'|'dividends_paid_out'|'signup_con'|'signup_email'|'total_assets'|'dividends_reinvested'|'share_value'|'spv_contributions'|'spv_filter_date'|'recent_contributions'|'authentication_code'|'oitsPlusAcquisition'|'dividends_empty'} [tooltip_type] Type of tooltip
 */

export const SpecialEventType = {
  Identify: "$identify",
  Group: "$groupidentify"
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultOptions = {
  plan: {
    version: '101',
    branch: 'main',
    source: 'di_web',
    versionId: '10a2d01a-4d59-4a1b-82ee-dabb3d2607a8'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-javascript-ampli',
      sourceVersion: '1.0.0'
    }
  }
};

export class Identify {
  constructor(properties) {
    this.event_type = SpecialEventType.Identify;
    this.event_properties = properties;
  }
}

export class AdminRegistrationIntended {
  constructor(properties) {
    this.event_type = 'admin_registration_intended';
    this.event_properties = properties;
  }
}

export class BackButtonClicked {
  constructor(properties) {
    this.event_type = 'back_button_clicked';
    this.event_properties = properties;
  }
}

export class BeaconArticleViewed {
  constructor(properties) {
    this.event_type = 'beacon_article_viewed';
    this.event_properties = properties;
  }
}

export class BeaconClicked {
  constructor(properties) {
    this.event_type = 'beacon_clicked';
    this.event_properties = properties;
  }
}

export class BeaconClosed {
  constructor(properties) {
    this.event_type = 'beacon_closed';
    this.event_properties = properties;
  }
}

export class BeaconEmailSent {
  constructor(properties) {
    this.event_type = 'beacon_email_sent';
    this.event_properties = properties;
  }
}

export class BeaconSearched {
  constructor(properties) {
    this.event_type = 'beacon_searched';
    this.event_properties = properties;
  }
}

export class ContentNavClicked {
  constructor(properties) {
    this.event_type = 'content_nav_clicked';
    this.event_properties = properties;
  }
}

export class EmbeddedBeaconClicked {
  constructor(properties) {
    this.event_type = 'embedded_beacon_clicked';
    this.event_properties = properties;
  }
}

export class ErrorEncountered {
  constructor(properties) {
    this.event_type = 'error_encountered';
    this.event_properties = properties;
  }
}

export class ExternalLinkClicked {
  constructor(properties) {
    this.event_type = 'external_link_clicked';
    this.event_properties = properties;
  }
}

export class EyeIconClicked {
  constructor(properties) {
    this.event_type = 'eye_icon_clicked';
    this.event_properties = properties;
  }
}

export class ForgotPasswordClicked {
  constructor(properties) {
    this.event_type = 'forgot_password_clicked';
    this.event_properties = properties;
  }
}

export class LinkExpiredClicked {
  constructor(properties) {
    this.event_type = 'link_expired_clicked';
    this.event_properties = properties;
  }
}

export class LoginCompleted {
  constructor(properties) {
    this.event_type = 'login_completed';
    this.event_properties = properties;
  }
}

export class LoginIntended {
  constructor(properties) {
    this.event_type = 'login_intended';
    this.event_properties = properties;
  }
}

export class LoginLinkClicked {
  constructor(properties) {
    this.event_type = 'login_link_clicked';
    this.event_properties = properties;
  }
}

export class LoginNextClicked {
  constructor(properties) {
    this.event_type = 'login_next_clicked';
    this.event_properties = properties;
  }
}

export class LoginRegistrationIntended {
  constructor(properties) {
    this.event_type = 'login_registration_intended';
    this.event_properties = properties;
  }
}

export class MfaPasskeyCopied {
  constructor(properties) {
    this.event_type = 'mfa_passkey_copied';
    this.event_properties = properties;
  }
}

export class MfaRegistrationCompleted {
  constructor(properties) {
    this.event_type = 'mfa_registration_completed';
    this.event_properties = properties;
  }
}

export class MfaRegistrationFailed {
  constructor(properties) {
    this.event_type = 'mfa_registration_failed';
    this.event_properties = properties;
  }
}

export class MfaVerifyClicked {
  constructor(properties) {
    this.event_type = 'mfa_verify_clicked';
    this.event_properties = properties;
  }
}

export class PasswordCreated {
  constructor(properties) {
    this.event_type = 'password_created';
    this.event_properties = properties;
  }
}

export class PasswordSetIntended {
  constructor(properties) {
    this.event_type = 'password_set_intended';
    this.event_properties = properties;
  }
}

export class PrivacyPolicyClicked {
  constructor(properties) {
    this.event_type = 'privacy_policy_clicked';
    this.event_properties = properties;
  }
}

export class RegistrationCompleted {
  constructor(properties) {
    this.event_type = 'registration_completed';
    this.event_properties = properties;
  }
}

export class ResendEmailClicked {
  constructor(properties) {
    this.event_type = 'resend_email_clicked';
    this.event_properties = properties;
  }
}

export class SendAccountNumberReminderCancelled {
  constructor(properties) {
    this.event_type = 'send_account_number_reminder_cancelled';
    this.event_properties = properties;
  }
}

export class SendAccountNumberReminderClicked {
  constructor(properties) {
    this.event_type = 'send_account_number_reminder_clicked';
    this.event_properties = properties;
  }
}

export class SendAccountNumberReminderSent {
  constructor(properties) {
    this.event_type = 'send_account_number_reminder_sent';
    this.event_properties = properties;
  }
}

export class TermsAndConditionsClicked {
  constructor(properties) {
    this.event_type = 'terms_and_conditions_clicked';
    this.event_properties = properties;
  }
}

export class TooltipViewed {
  constructor(properties) {
    this.event_type = 'tooltip_viewed';
    this.event_properties = properties;
  }
}

export class UserVerificationIntended {
  constructor(properties) {
    this.event_type = 'user_verification_intended';
    this.event_properties = properties;
  }
}

// prettier-ignore
export class Ampli {
  constructor() {
    /* @type {AmplitudeClient|undefined} */
    this.amplitude = undefined;
    this.disabled = false;
    /* @type {Middleware[]} */
    this.middlewares = [];
  }

  /**
   * @return {AmplitudeClient}
   */
  get client() {
    this.isInitializedAndEnabled();
    return this.amplitude;
  }

  /**
   * @return {boolean}
   */
  get isLoaded() {
    return this.amplitude != null;
  }

  /**
   * @private
   * @return {boolean}
   */
  isInitializedAndEnabled() {
    if (!this.isLoaded) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   * @param {LoadOptions} options Configuration options to initialize the Ampli SDK with. 'environment', 'client.apiKey' or 'client.instance' is required.
   */
  load(options) {
    this.disabled = options?.disabled ?? false;

    if (this.isLoaded) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return;
    }

    let apiKey;
    if (options?.client?.apiKey) {
      apiKey = options.client.apiKey;
    } else if (options?.environment) {
      apiKey = ApiKey[options.environment];
    }

    if (options?.client?.instance) {
      this.amplitude = options?.client?.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.getInstance();
      this.amplitude?.init(apiKey, undefined, { ...DefaultOptions, ...(options?.client?.options ?? options?.client?.config) });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }
  }

  /**
   * Identify a user and set or update that user's properties.
   *
   * @param {string|undefined} userId The user's id.
   * @param {Object} [properties] The user's properties.
   * @param {string} [properties.email] the email address of the user
   * @param {number} [properties.logins] the number of times a user has logged in
   * @param {'d2c'|'advised'|'adviser'|'admin'|'anonymous'|'internal_admin'|'investor'|'adviser-admin'} [properties.role] The users role
   * @param {string} [properties.uuid] The uuid of the user
   * @param {IdentifyOptions} [options] Optional event options.
   * @param {MiddlewareExtra} [extra] Extra unstructured data for middleware.
   */
  identify(userId, properties, options, extra) {
    if (!this.isInitializedAndEnabled()) {
      return;
    }

    const event = {
      event_type: SpecialEventType.Identify,
      event_properties: properties,
      user_id: userId || options?.user_id,
      device_id: options?.device_id
    };
    this.runMiddleware({ event, extra }, payload => {
      if (payload.event.user_id) {
        this.amplitude?.setUserId(payload.event.user_id);
      }
      if (payload.event.device_id) {
        this.amplitude?.setDeviceId(payload.event.device_id);
      }

      this._identify(payload.event, options);
    });
  }

  _identify(event, options) {
    const ampIdentify = new amplitude.Identify();
    if (event.event_properties != null) {
      for (const [key, value] of Object.entries(event.event_properties)) {
        ampIdentify.set(key, value);
      }
    }
    this.amplitude.identify(
      ampIdentify,
      options?.callback,
      options?.errorCallback
    );
  }

  /**
   * Set Group for the current user
   *
   * @param {String} name
   * @param {String|String[]} value
   * @param {GroupOptions} [options]
   * @param {MiddlewareExtra} [extra]
   */
  setGroup(name, value, options, extra) {
    if (!this.isInitializedAndEnabled()) {
      return;
    }

    this.amplitude?.setGroup(name, value);
  }

  /**
   * Identify a group.
   *
   * @param {string} groupType The group type.
   * @param {string|string[]} groupName The group name.
   * @param {GroupOptions} [options] Options for this groupIdentify call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  groupIdentify(groupType, groupName, options, extra) {
    if (!this.isInitializedAndEnabled()) {
      return;
    }

    const event = {
      event_type: SpecialEventType.Group,
      user_id: options?.user_id,
      device_id: options?.device_id
    };
    this.runMiddleware({ event, extra }, payload => {
      const e = payload.event;
      if (e.user_id) {
        this.amplitude.setUserId(e.user_id);
      }
      if (e.device_id) {
        this.amplitude.setDeviceId(e.device_id);
      }
      const amplitudeIdentify = new amplitude.Identify();
      if (e.event_properties != null) {
        for (const [key, value] of Object.entries(e.event_properties)) {
          amplitudeIdentify.set(key, value);
        }
      }
      this.amplitude.groupIdentify(groupType, groupName, amplitudeIdentify, options?.callback);
    });
  }

  /**
   * Track event
   *
   * @param {BaseEvent} event The event to track.
   * @param {EventOptions} [options] Optional event options.
   * @param {MiddlewareExtra} [extra] Extra unstructured data for middleware.
   */
  track(event, options, extra) {
    if (!this.isInitializedAndEnabled()) {
      return;
    }

    const trackEvent = { ...event, ...options };
    this.runMiddleware({ event: trackEvent, extra }, payload => {
      if (payload.event.user_id) {
        this.amplitude?.setUserId(payload.event.user_id);
      }
      if (payload.event.device_id) {
        this.amplitude?.setDeviceId(payload.event.device_id);
      }

      const userProperties = payload.event.user_properties;
      if (userProperties) {
        const identifyEvent = {
          event_type: SpecialEventType.Identify,
          event_properties: userProperties,
          user_id: payload.event.user_id,
          device_id: payload.event.device_id
        };
        this._identify(identifyEvent, options);
      }

      this.amplitude.logEvent(
        payload.event.event_type,
        payload.event.event_properties,
        options?.callback,
        options?.errorCallback,
      );
    });
  }

  /**
   * admin_registration_intended
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/admin_registration_intended)
   *
   * Admin sign up form clicked 
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  adminRegistrationIntended(properties, options, extra) {
    this.track(new AdminRegistrationIntended(properties), options, extra);
  }

  /**
   * back_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/back_button_clicked)
   *
   * Login password page, back button is pressed 
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  backButtonClicked(properties, options, extra) {
    this.track(new BackButtonClicked(properties), options, extra);
  }

  /**
   * beacon_article_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/beacon_article_viewed)
   *
   * Called when a user clicks into an article in the Beacon modal
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.article_id] The id of the knowledge base article clicked
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  beaconArticleViewed(properties, options, extra) {
    this.track(new BeaconArticleViewed(properties), options, extra);
  }

  /**
   * beacon_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/beacon_clicked)
   *
   * Called when a user clicks the Beacon "FAQs & Live Chat" button
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  beaconClicked(properties, options, extra) {
    this.track(new BeaconClicked(properties), options, extra);
  }

  /**
   * beacon_closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/beacon_closed)
   *
   * Called when a user closes the Beacon modal
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  beaconClosed(properties, options, extra) {
    this.track(new BeaconClosed(properties), options, extra);
  }

  /**
   * beacon_email_sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/beacon_email_sent)
   *
   * Called when a user sends a support query via Beacon
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  beaconEmailSent(properties, options, extra) {
    this.track(new BeaconEmailSent(properties), options, extra);
  }

  /**
   * beacon_searched
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/beacon_searched)
   *
   * Called when a user searchs for an article in the Beacon modal
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'scv'|'client_list'|'investment_details'|'illustration_investment_details'|'application_investment_details'} [properties.destination] The page the user navigates to
   * @param {string} [properties.search_content] what the user is searching for - the string of characters in the input value when dropdown is closed
   * @param {'clients'|'amount'|'advisers'} [properties.search_type] What is the user searching for
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {boolean} [properties.successful] Has the customer successfully selected an item from the dropdown
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  beaconSearched(properties, options, extra) {
    this.track(new BeaconSearched(properties), options, extra);
  }

  /**
   * content_nav_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/content_nav_clicked)
   *
   * Called when a user navigates within OO using navigation in the content e.g. breadcrumb
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {'Account information'|'Back to Clients'|'Back to Investments'|'Breadcrumb Client Name'|'Breadcrumb My Clients'|'Discover more'|'Future Gen back to Portfolio Stories'|'Portfolio Stories'|'FGVCT Product page'|'Close icon'|'New snippet'|'New tab'|'Back to my account'|'Try again'} [properties.navigation_type] the method of navigation
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  contentNavClicked(properties, options, extra) {
    this.track(new ContentNavClicked(properties), options, extra);
  }

  /**
   * embedded_beacon_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/embedded_beacon_clicked)
   *
   * Called when a user clicks on an embedded beacon article link
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.article_id] The id of the knowledge base article clicked
   * @param {'beacon - no clients'|'mailto:support@octopusinvestments.com'|'fgvct_simon_rogerson'|'fgvct_octopus_giving'|'0800 316 2295'|'beacon - tab error'|'new_investor'|'change_details'|'missing_fields'|'new_adviser'|'continue_new_investor'|'continue_missing_fields'|'0800 316 2067'|'mfa_microsoft'|'mfa_google'|'beacon_mfa_contact'|'mfa_apple'|'ill_expired_login'|'beacon_get_in_touch'|'ill_expired_create'|'ill_expired_contact'} [properties.external_link_clicked] The external link clicked - either from event external_link_clicked or external_app_clicked or embedded_beacon_clicked
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  embeddedBeaconClicked(properties, options, extra) {
    this.track(new EmbeddedBeaconClicked(properties), options, extra);
  }

  /**
   * error_encountered
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/error_encountered)
   *
   * Called when a user encouters an error -e.g. 500 or 404
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.error_code] A value we will sent, that means something   e.g. Page not found, document not found etc.
   * @param {string} [properties.error_message] The description of the error - extra details
   * @param {string} [properties.error_name] The "Redux store object name" that identifies the error in the codebase
   * @param {string} [properties.error_referrer] The page the user was on when they encountered the error - e.g. https://portal.octopusinvestments.com/clients
   * @param {number} [properties.error_status] e.g 500; 404 etc.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  errorEncountered(properties, options, extra) {
    this.track(new ErrorEncountered(properties), options, extra);
  }

  /**
   * external_link_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/external_link_clicked)
   *
   * Called when a user clicks on an external link
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'beacon - no clients'|'mailto:support@octopusinvestments.com'|'fgvct_simon_rogerson'|'fgvct_octopus_giving'|'0800 316 2295'|'beacon - tab error'|'new_investor'|'change_details'|'missing_fields'|'new_adviser'|'continue_new_investor'|'continue_missing_fields'|'0800 316 2067'|'mfa_microsoft'|'mfa_google'|'beacon_mfa_contact'|'mfa_apple'|'ill_expired_login'|'beacon_get_in_touch'|'ill_expired_create'|'ill_expired_contact'} [properties.external_link_clicked] The external link clicked - either from event external_link_clicked or external_app_clicked or embedded_beacon_clicked
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  externalLinkClicked(properties, options, extra) {
    this.track(new ExternalLinkClicked(properties), options, extra);
  }

  /**
   * eye_icon_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/eye_icon_clicked)
   *
   * Create password/login page click eye icon 
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  eyeIconClicked(properties, options, extra) {
    this.track(new EyeIconClicked(properties), options, extra);
  }

  /**
   * forgot_password_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/forgot_password_clicked)
   *
   * Called when a user clicks "forgot password"
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  forgotPasswordClicked(properties, options, extra) {
    this.track(new ForgotPasswordClicked(properties), options, extra);
  }

  /**
   * link_expired_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/link_expired_clicked)
   *
   * Link has expired page email filled and press send new link
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.email] the email address of the user
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  linkExpiredClicked(properties, options, extra) {
    this.track(new LinkExpiredClicked(properties), options, extra);
  }

  /**
   * login_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/login_completed)
   *
   * Login page email and password verified and user clicks login
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} properties The event's properties.
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {string} properties.email Property has no description in tracking plan.
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  loginCompleted(properties, options, extra) {
    this.track(new LoginCompleted(properties), options, extra);
  }

  /**
   * login_intended
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/login_intended)
   *
   * Called when a user presses "Login"
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  loginIntended(properties, options, extra) {
    this.track(new LoginIntended(properties), options, extra);
  }

  /**
   * login_link_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/login_link_clicked)
   *
   * Called when a user tried to generate a "Remind me my CON" link to an already registered email, then clicks "login" on the prompt
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  loginLinkClicked(properties, options, extra) {
    this.track(new LoginLinkClicked(properties), options, extra);
  }

  /**
   * login_next_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/login_next_clicked)
   *
   * Called when a user presses the "Next" button after they've entered both their email & password; **and** they have MFA enabled so they will still need to enter their code
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_email_criteria_met] Incorrect OR correct
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_password_criteria_met] Property has no description in tracking plan.
   * @param {boolean} [properties.di_passwords_match] True or False
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  loginNextClicked(properties, options, extra) {
    this.track(new LoginNextClicked(properties), options, extra);
  }

  /**
   * login_registration_intended
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/login_registration_intended)
   *
   * Called when a user presses the "Next" button on the "Log in or create an account" page after entering their email
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_email_criteria_met] Incorrect OR correct
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_password_criteria_met] Property has no description in tracking plan.
   * @param {boolean} [properties.di_passwords_match] True or False
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  loginRegistrationIntended(properties, options, extra) {
    this.track(new LoginRegistrationIntended(properties), options, extra);
  }

  /**
   * mfa_passkey_copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/mfa_passkey_copied)
   *
   * Called when a customer copies the passkey from the MFA flow
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  mfaPasskeyCopied(properties, options, extra) {
    this.track(new MfaPasskeyCopied(properties), options, extra);
  }

  /**
   * mfa_registration_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/mfa_registration_completed)
   *
   * Called when a customer clicks "Verify" in the "Register for "Multi-Factor Authentication" page in DI and it is successful
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  mfaRegistrationCompleted(properties, options, extra) {
    this.track(new MfaRegistrationCompleted(properties), options, extra);
  }

  /**
   * mfa_registration_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/mfa_registration_failed)
   *
   * Called when a customer clicks "Verify" in the "Register for "Multi-Factor Authentication" page in DI and it fails
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  mfaRegistrationFailed(properties, options, extra) {
    this.track(new MfaRegistrationFailed(properties), options, extra);
  }

  /**
   * mfa_verify_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/mfa_verify_clicked)
   *
   * Called when a customer clicks "Verify" in the "Register for "Multi-Factor Authentication" page in DI
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  mfaVerifyClicked(properties, options, extra) {
    this.track(new MfaVerifyClicked(properties), options, extra);
  }

  /**
   * password_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/password_created)
   *
   * Called when a user successfully creates their password
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {string} [properties.email] the email address of the user
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  passwordCreated(properties, options, extra) {
    this.track(new PasswordCreated(properties), options, extra);
  }

  /**
   * password_set_intended
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/password_set_intended)
   *
   * Passwords match and "create password" button is clicked
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {boolean} [properties.di_email_criteria_met] Incorrect OR correct
   * @param {boolean} [properties.di_password_criteria_met] Property has no description in tracking plan.
   * @param {boolean} [properties.di_passwords_match] True or False
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  passwordSetIntended(properties, options, extra) {
    this.track(new PasswordSetIntended(properties), options, extra);
  }

  /**
   * privacy_policy_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/privacy_policy_clicked)
   *
   * Called when a user click on privacy policy in a DI flow
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  privacyPolicyClicked(properties, options, extra) {
    this.track(new PrivacyPolicyClicked(properties), options, extra);
  }

  /**
   * registration_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/registration_completed)
   *
   * Calls when a user enters a correct CON and presses "Register"
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  registrationCompleted(properties, options, extra) {
    this.track(new RegistrationCompleted(properties), options, extra);
  }

  /**
   * resend_email_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/resend_email_clicked)
   *
   * This event tracks when a user clicks on the "Resend Email" button in the Login/Registration flow
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  resendEmailClicked(properties, options, extra) {
    this.track(new ResendEmailClicked(properties), options, extra);
  }

  /**
   * send_account_number_reminder_cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/send_account_number_reminder_cancelled)
   *
   * Called when a user presses "Cancel" on the "Send an account number reminder" modal
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  sendAccountNumberReminderCancelled(properties, options, extra) {
    this.track(new SendAccountNumberReminderCancelled(properties), options, extra);
  }

  /**
   * send_account_number_reminder_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/send_account_number_reminder_clicked)
   *
   * Called when a customer clicks "Send account number reminder flow" on the "Register with Octopus" screen
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  sendAccountNumberReminderClicked(properties, options, extra) {
    this.track(new SendAccountNumberReminderClicked(properties), options, extra);
  }

  /**
   * send_account_number_reminder_sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/send_account_number_reminder_sent)
   *
   * Called when a user presses "Send reminder" on the "Send an account number reminder" modal
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_email_criteria_met] Incorrect OR correct
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {boolean} [properties.di_password_criteria_met] Property has no description in tracking plan.
   * @param {boolean} [properties.di_passwords_match] True or False
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  sendAccountNumberReminderSent(properties, options, extra) {
    this.track(new SendAccountNumberReminderSent(properties), options, extra);
  }

  /**
   * terms_and_conditions_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/terms_and_conditions_clicked)
   *
   * User click on t&cs 
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  termsAndConditionsClicked(properties, options, extra) {
    this.track(new TermsAndConditionsClicked(properties), options, extra);
  }

  /**
   * tooltip_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/tooltip_viewed)
   *
   * Called when a user view a tooltip
   *
   * Owner: Sam Bravery
   *
   * @param {Object} [properties] The event's properties.
   * @param {'application_flow'|'applications_page'|'apply_portal'|'check_email_page'|'client_details_page'|'client_list_export_button'|'client_list_page'|'con_page'|'dashboard_illustrations'|'enter_password_page'|'illustration_page'|'link_expired_page'|'locked_out_page'|'my_account'|'other'|'page_404'|'page_500'|'product_page'|'reports_page'|'resource_centre'|'savings_homepage'|'scv_accounts'|'scv_communications'|'scv_deal_comms'|'scv_documents'|'set_password_page'|'sign_up_login_page'|'single_client_view'|'single_portfolio_view'|'spv_adviser_charges'|'spv_cash_statements'|'spv_certificates'|'spv_dividends'|'spv_export_button'|'spv_trading_statements'|'spv_transactions'|'spv_valuations'|'spv_vct_valuation'|'top_nav'|'welcome_page'|'commission_statements'|'commission_statements_payment_amount'|'resources_page'|'webinar_event_page'|'bottom_nav'|'promo_box'|'business_line_page'|'reset_password_page'|'scv'|'fgvct_product_page'|'spv_contributions'|'scv_portfolio_stories'|'spv'|'company_page'|'scv_portfolios'|'illustrations_modal'|'application_investor_name'|'application_investment_details'|'application_summary'|'application_toast'|'application_adviser_name'|'maintenance_page'|'illustration_investment_details'|'illustration_summary'|'spv_recent_contributions'|'spv_pending_investment'|'application_investor_review'|'application_investor_fail'|'di_login_page'|'di_create_password_page'|'home_page'|'di_confirm_account_number'|'di_check_your_email_page'|'illustration_investment_details_page'|'illustrations_summary'|'di_login_page_error'|'illustration_investor_name'|'my_account_security'|'mfa_register_for_mfa'|'mfa_register_error_page'|'hamburger_menu'|'illustration_expired_page'|'illustration_error_page'} [properties.location] The page and/or element (e.g. home_nav ; home_main ; clients_nav etc.) where a customer acess takes place
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {'accrued_fees'|'adviser_charges'|'amc'|'cash_statement'|'con'|'current_value'|'dividends_paid_out'|'signup_con'|'signup_email'|'total_assets'|'dividends_reinvested'|'share_value'|'spv_contributions'|'spv_filter_date'|'recent_contributions'|'authentication_code'|'oitsPlusAcquisition'|'dividends_empty'} [properties.tooltip_type] Type of tooltip
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  tooltipViewed(properties, options, extra) {
    this.track(new TooltipViewed(properties), options, extra);
  }

  /**
   * user_verification_intended
   *
   * [View in Tracking Plan](https://data.amplitude.com/oi/Octopus%20Investments/events/main/latest/user_verification_intended)
   *
   * Called when a user enters a CON & presses Register
   *
   * Owner: geri@octopuslabs.com
   *
   * @param {Object} [properties] The event's properties.
   * @param {string} [properties.di_con_entered] Property has no description in tracking plan.
   * @param {string} [properties.di_email_entered] Property has no description in tracking plan.
   * @param {'locked temp'|'permanent lock'|'successful'|'expired'|'input error'|'server error'|'unregistered'} [properties.di_status] Statuses can be locked temp, permanent lock, successful, expired, input error, server error
   * @param {boolean} [properties.is_user_registered] Check whether user attempted to Login is already Registered (Y/N)
   * @param {boolean} [properties.mfa_status] Has the customer got MFA enabled
   * @param {*} [properties.source_website] Property has no description in tracking plan.
   * @param {string} [properties.user_id] the id of the user
   * @param {'investor'|'adviser'|'adviser_admin'|'unknown'} [properties.user_type] Property has no description in tracking plan.
   * @param {boolean} [properties.view_as] Has this event been triggered by someone 'Viewing As' the customer
   * @param {EventOptions} [options] Options for this track call.
   * @param {MiddlewareExtra} [extra] Extra untyped parameters for use in middleware.
   */
  userVerificationIntended(properties, options, extra) {
    this.track(new UserVerificationIntended(properties), options, extra);
  }

  /**
   * Add new middleware to end of chain
   *
   * @param {Middleware} middleware
   */
  addEventMiddleware(middleware) {
    this.middlewares.push(middleware);
  }

  /**
   * Runs all middleware
   *
   * @param {MiddlewarePayload} payload
   * @param {MiddlewareNext} next The method to run after all middleware.
   *
   * @protected
   */
  runMiddleware(payload, next) {
    let curMiddlewareIndex = -1;
    const middlewareCount = this.middlewares.length;

    const middlewareNext = curPayload => {
      curMiddlewareIndex += 1;
      if (curMiddlewareIndex < middlewareCount) {
        this.middlewares[curMiddlewareIndex](curPayload, _next);
      } else {
        next(curPayload);
      }
    };

    const _next = middlewareCount > 0 ? middlewareNext : next;

    _next(payload);
  }
}

export const ampli = new Ampli();
